import { useEffect } from "react";
import { LanderConfigAction, useLanderConfig } from "../commons/ConfigContext";

import { LanderConfig } from "../types/LanderConfig";
import { isControlCohort } from "./helper";
import { ErrorCode, System } from "../commons/Constants";
import { sendErrorEvent } from "../commons/LanderEvent";

const experimentId = "parking_pw_4396";

// For more details see https://github.com/gdcorp-domains/parking-content-site
export const rsocRedirect = async (landerConfig: LanderConfig, eid: string) => {
  const rsocUrl = new URL(
    landerConfig.rsoc.path,
    "https://www.searchhounds.com"
  );

  // Query params that will be used in searchhounds
  rsocUrl.searchParams.set("psystem", "PW");
  rsocUrl.searchParams.set("domain", window.location.hostname);
  if (landerConfig.adSense.keywords) {
    rsocUrl.searchParams.set("terms", landerConfig.adSense.keywords.join(","));
  }
  rsocUrl.searchParams.set("expId", `${eid}-${landerConfig.experiment.cohort}`);

  try {
    location.assign(rsocUrl.toString());
  } catch (error) {
    sendErrorEvent(landerConfig, ErrorCode.ERROR_RSOC_REDIRECT);
  }
};

export function useRsocExperiment() {
  const { landerConfig, landerConfigDispatch } = useLanderConfig();
  const { experiment: { key, cohort } = {} } = landerConfig;

  const inExperiment =
    key === experimentId &&
    !!landerConfig.rsoc?.path &&
    landerConfig.system === System.PARKWEB;
  const inTreatmentCohort = inExperiment && cohort && !isControlCohort(cohort);

  useEffect(() => {
    if (inExperiment && inTreatmentCohort) {
      rsocRedirect(landerConfig, experimentId);
    }
  }, [inExperiment, inTreatmentCohort, landerConfig]);

  useEffect(() => {
    if (!inExperiment) return;

    landerConfigDispatch({
      type: LanderConfigAction.UPDATE_BANNER_AND_CHANNEL_BY_TREATMENT,
      payload: {
        inTreatmentCohort,
      },
    });
  }, [inExperiment, landerConfigDispatch, inTreatmentCohort]);

  return { inTreatmentCohort, inExperiment, cohort };
}
